import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Z_INDEX } from '~/assets/styles/base';

const HeaderWrapper = styled.div`
  position: relative;
  top: 0;
  width: 100%;
  z-index: ${Z_INDEX.header + 1};
`;

const GmoHeader: React.FC = () => {
  useEffect(() => {
    const setHeight = () => {
      const gmoHeader = document.querySelector('.ghta') as HTMLElement | null;
      if (gmoHeader) {
        const height = gmoHeader.offsetHeight || 28; // set default 28px
        document.documentElement.style.setProperty('--gmo-header-height', `${height}px`);
      }
    };

    if (!document.getElementById('gmoheadertag')) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.charset = 'UTF-8';
      script.src = 'https://cache.img.gmo.jp/gmo/header/script.min.js';
      script.id = 'gmoheadertag';
      script.async = true;
      script.onload = setHeight;
      document.body.appendChild(script);
    } else {
      setHeight();
    }

    window.addEventListener('resize', setHeight);
    return () => {
      window.removeEventListener('resize', setHeight);
    };
    // if (document.getElementById('gmoheadertag')) return;
    // const script = document.createElement('script');
    // script.type = 'text/javascript';
    // script.charset = 'UTF-8';
    // script.src = 'https://cache.img.gmo.jp/gmo/header/script.min.js';
    // script.id = 'gmoheadertag';
    // script.async = true;
    // document.body.appendChild(script);
  }, []);

  return (
    <HeaderWrapper>
      <div className="ghta" />
    </HeaderWrapper>
  );
};

export default GmoHeader;
